export default
{
        // url: this.$store.state.http.calidad.YYYY,
    listComites: "/calidad/listComites",
    listCargosComite: "/calidad/listCargosComite",

    guardaIaas: "/calidad/guardaIaas",
    listIaas: "/calidad/listIaas",

    guardaIntegranteComite: "/calidad/guardaIntegranteComite",
    listIntegrantesComite: "/calidad/listIntegrantesComite",
    guardaInvitadoReunion: "/calidad/guardaInvitadoReunion",
    borraInvitado: "/calidad/borraInvitado",

    getReunion: "/calidad/getReunion",
    guardaReunion: "/calidad/guardaReunion",
    listEventos: "/calidad/listReuniones",

    guardaReunionAsunto: "/calidad/guardaReunionAsunto",
    listaReunionAsuntos: "/calidad/listaReunionAsuntos",

    guardaReunionAcuerdo: "/calidad/guardaReunionAcuerdo",
    listReunionesAcuerdos: "/calidad/listReunionesAcuerdos",

    guardaIdMeds: "/calidad/guardaIdMeds",
    listIdMeds: "/calidad/listIdMeds",

    guardaCarroRojo: "/calidad/guardaCarroRojo",
    listCarroRojo: "/calidad/listCarroRojo",

    guardaInsumosLavado: "/calidad/guardaInsumosLavado",
    listEvalInsumosLavado: "/calidad/listEvalInsumosLavado",

    guardaLavadoManos: "/calidad/guardaLavadoManos",
    listLavadoManos: "/calidad/listLavadoManos",

    guarda5momentos: "/calidad/guarda5momentos",
    list5momentos: "/calidad/list5momentos",

    guardaDatosId: "/calidad/guardaDatosId",
    listDatosId: "/calidad/listDatosId",

    guardaDatosHospital: "/calidad/guardaDatosHospital",
    listDatosHospital: "/calidad/listDatosHospital",

    guardaRiesgoCaidas: "/calidad/guardaRiesgoCaidas",
    listRiesgoCaidas: "/calidad/listRiesgoCaidas",

    guardaArchivoReunion: "/calidad/guardaArchivoReunion",
    listArchivosReunion: "/calidad/listArchivosReunion",
    getArchivosReunion: "/calidad/getArchivosReunion",

    guardaManual: "/calidad/guardaManual",
    listManuales: "/calidad/listManuales",
    getManual: "/calidad/getManual",

    guardaArchivoUnidad:"/calidad/guardaArchivoUnidad",
    listArchivoUnidad:"/calidad/listArchivoUnidad",

    listSimulacro:"/calidad/listSimulacro",
    //listSimulacroEvaluacion:"/calidad/listSimulacroEvaluaicion",
    guardaSimulacro:"/calidad/guardaSimulacro",
    //guardaSimulacroEvaluacion:"/calidad/guardaSimulacroEvaluaion",

}
